import type { PlayerProfile } from "../types";

export function playerFacingDisplayName(profile?: PlayerProfile): string {
  const candidate = profile?.displayName.trim();
  return candidate && !candidate.startsWith("Joueur-")
    ? candidate
    : "Seigneur sans nom";
}
